import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-659b0792"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护优惠活动信息")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动券数量", -1));
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}优惠活动信息`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      "label-width": "120px",
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "优惠活动名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.name = $event),
              placeholder: "请输入优惠活动名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "优惠活动编码",
            prop: "code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.code = $event),
              placeholder: "请输入优惠活动编码"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            required: "",
            label: "活动时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formModel.dates,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.dates = $event),
              type: "datetimerange",
              "range-separator": "至",
              "start-placeholder": "开始时间",
              "end-placeholder": "截至时间",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "使用端"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formModel.employ,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.employ = $event),
              placeholder: "请选择",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.emploies, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.name,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "couponTimes"
          }, {
            label: _withCtx(() => [_createElementVNode("div", null, [_hoisted_3, _createVNode(_component_el_popover, {
              trigger: "hover",
              content: "0表示无限制"
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "iconfont icon-question-circle",
                style: {
                  "padding-left": "5px"
                }
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              style: {
                "width": "100%"
              },
              modelValue: $data.formModel.couponTimes,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.couponTimes = $event),
              min: 0,
              "controls-position": "right"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "优惠类型",
            prop: "promotionType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: $data.formModel.promotionType,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formModel.promotionType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_button, {
                label: "固定金额"
              }), _createVNode(_component_el_radio_button, {
                label: "随机金额"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), $data.formModel.promotionType === '固定金额' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 0,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "优惠券金额",
            prop: "money"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              style: {
                "width": "100%"
              },
              modelValue: $data.formModel.money,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formModel.money = $event),
              min: 0.01,
              "controls-position": "right"
            }, null, 8, ["modelValue", "min"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), $data.formModel.promotionType === '随机金额' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 1,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "单位",
            prop: "unit"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formModel.unit,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.formModel.unit = $event),
              placeholder: "请选择",
              style: {
                "width": "100%"
              },
              onChange: $options.changeUnit
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.units, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.name,
                  label: item.name,
                  value: item.name
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onChange"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), $data.formModel.promotionType === '随机金额' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 2,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "总金额",
            prop: "totalAmount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              style: {
                "width": "100%"
              },
              modelValue: $data.formModel.totalAmount,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.formModel.totalAmount = $event),
              min: 0.01,
              precision: 2,
              "controls-position": "right"
            }, null, 8, ["modelValue", "min"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), $data.formModel.promotionType === '随机金额' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 3,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "最小金额",
            prop: "minAmount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              style: {
                "width": "100%"
              },
              modelValue: $data.formModel.minAmount,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.formModel.minAmount = $event),
              precision: $data.precision,
              "controls-position": "right"
            }, null, 8, ["modelValue", "precision"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), $data.formModel.promotionType === '随机金额' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 4,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "最大金额",
            prop: "maxAmount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              style: {
                "width": "100%"
              },
              modelValue: $data.formModel.maxAmount,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.formModel.maxAmount = $event),
              min: 0.01,
              precision: $data.precision,
              "controls-position": "right"
            }, null, 8, ["modelValue", "min", "precision"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "券失效方式",
            prop: "couponExpirationType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: $data.formModel.couponExpirationType,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.formModel.couponExpirationType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_button, {
                label: "固定时间"
              }), _createVNode(_component_el_radio_button, {
                label: "动态时间"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [$data.formModel.couponExpirationType === '固定时间' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "失效时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formModel.couponExpirationTime,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.formModel.couponExpirationTime = $event),
              type: "datetime",
              placeholder: "选择券固定失效时间",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "动态时间数量",
            prop: "couponExpriationDynamicValue"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.couponExpriationDynamicValue,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.formModel.couponExpriationDynamicValue = $event),
              placeholder: "时间数量",
              class: "input-with-select",
              type: "number"
            }, {
              append: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: $data.formModel.couponExpriationDynamicUnit,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.formModel.couponExpriationDynamicUnit = $event),
                placeholder: "单位",
                style: {
                  "width": "72px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "秒",
                  value: "秒"
                }), _createVNode(_component_el_option, {
                  label: "分钟",
                  value: "分钟"
                }), _createVNode(_component_el_option, {
                  label: "小时",
                  value: "小时"
                }), _createVNode(_component_el_option, {
                  label: "天",
                  value: "天"
                }), _createVNode(_component_el_option, {
                  label: "月",
                  value: "月"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }))]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "链接地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formModel.accessAddress,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.formModel.accessAddress = $event),
              placeholder: "请输入链接地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "活动图片"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              "file-list": $data.formModel.imgs,
              "onUpdate:fileList": _cache[16] || (_cache[16] = $event => $data.formModel.imgs = $event),
              action: "",
              limit: "1",
              "list-type": "picture-card",
              "on-change": $options.changeFile,
              "on-preview": $options.handlePictureCardPreview,
              "on-remove": _ctx.handleRemove,
              "auto-upload": false
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "iconfont icon-file-add"
              })]),
              _: 1
            }, 8, ["file-list", "on-change", "on-preview", "on-remove"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['ridePromotion_add', 'ridePromotion_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.dialogVisible = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      "w-full": "",
      style: {
        "width": "100%"
      },
      src: $data.dialogImageUrl
    }, null, 8, _hoisted_4)]),
    _: 1
  }, 8, ["modelValue"])]);
}